import type { NameProps } from './types.js';
import { Ikon } from '@studio/design-system/button';
import { Mediator } from '@studio/design-system/input';
import { Ellipses } from '@studio/design-system/label';
import { useDoubleClick } from '@studio/react-utils/hooks';
import { toString } from '@tryiris-ai/js-types';
import type { ReactElement } from 'react';
import { useState } from 'react';

/** `<Name>` component. */
export const Name = ({ agentId, wiring, machineName, ...props }: NameProps): ReactElement => {
  const [isEditing, setEditing] = useState(false);
  const agent = wiring.agents[agentId];

  let isOnline = false;

  const clicks = useDoubleClick({
    onDoubleClick: (): void => {
      if (isOnline) {
        setEditing(true);
      }
    },

    onSingleClick: (): void => {
      // @fixme - currently does nothing.
    }
  });

  if (!agent) {
    return <div {...props} />;
  }

  const { id, name, status } = agent;
  isOnline = status === 'online';

  return (
    <div {...props}>
      {isEditing ? (
        <Mediator
          className='w-auto'
          focusOnMount
          onCancel={(): void => {
            setEditing(false);
          }}
          onCommit={(nextValue: string): void => {
            const nextName = toString(nextValue);

            if (nextName && nextName !== name) {
              wiring.handleRename(id, nextName);
            }

            setEditing(false);
          }}
          selectOnMount
          value={(name || undefined) ?? machineName}
        />
      ) : (
        <div className='relative flex items-center gap-8' {...clicks}>
          <Ellipses className='select-none text-base font-bold' title={name}>
            {(name || undefined) ?? machineName}
          </Ellipses>

          <div className='absolute bottom-0 left-full top-0 flex items-center'>
            {!!isOnline && (
              <Ikon
                icon='edit'
                onClick={(): void => {
                  setEditing(true);
                }}
              />
            )}
          </div>
        </div>
      )}
    </div>
  );
};
